<template>
	<div class="sip-view-page">
        <div class="nk-block-head nk-block-head-sm sip-view-head">
            <div class="nk-block-between">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{ trans('general.update') }}</h3>
                    <div class="nk-block-des text-soft">
                        <p>Review release details and apply updates.</p>
                    </div>
                </div>
                <span class="admin-status-badge" :class="product.current_version == product.latest_version && product.name ? 'admin-status-badge--success' : 'admin-status-badge--info'">
                    {{ product.current_version == product.latest_version && product.name ? 'Current' : 'Review' }}
                </span>
            </div>
        </div>

        <div class="row sip-view-grid">
            <div class="col-12 col-lg-8">
                <div class="card sip-view-card">
                    <div class="card-body">
                <div v-if="product.current_version == product.latest_version && product.name" class="sip-view-note">
                    <strong>No update available.</strong>
                    <span>Please check later for a new release.</span>
                </div>
                <div v-else>
                    <template v-if="!is_processing">
                        <div class="sip-view-rich" v-html="update_tips"></div>
                        <dl class="sip-view-dl mt-3" v-if="product.name">
                            <div class="sip-view-dl__row">
                                <dt>Version available</dt>
                                <dd>{{product.next_release_version}}</dd>
                            </div>
                            <div class="sip-view-dl__row">
                                <dt>Date of release</dt>
                                <dd>{{product.next_release_date | moment}}</dd>
                            </div>
                            <div class="sip-view-dl__row">
                                <dt>Update size</dt>
                                <dd>{{getFileSize(product.next_release_size)}}</dd>
                            </div>
                        </dl>
                        <div class="sip-view-rich mt-2" v-if="product.name" v-html="product.next_release_change_log"></div>
                        <div class="sip-view-actions">
                            <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" key="download" v-confirm="{ok: confirmDownload(0)}" v-if="!is_downloaded">Download</button>
                            <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" key="direct-update" v-confirm="{ok: confirmUpdate()}" v-if="is_downloaded">Update</button>
                            <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" key="download-update" v-confirm="{ok: confirmDownload(1)}" v-if="!is_downloaded">Download & Update</button>
                        </div>
                    </template>
                    <template v-else>
                        <div class="sip-view-note" role="status">
                            <strong>Update in progress</strong>
                            <span>Don't perform any action till we are performing update!</span>
                            <span v-if="is_downloading">Update Size ({{getFileSize(product.next_release_size)}}) - Downloading.....</span>
                            <span v-if="is_updating">Updating.....</span>
                        </div>
                        <div class="sip-view-actions" v-if="is_downloaded">
                            <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" key="update" v-confirm="{ok: confirmUpdate()}">Update</button>
                        </div>
                    </template>
                </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div class="card sip-view-card">
                    <div class="card-body">
                        <product :product="product" update="1"></product>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import product from './product'

	export default {
		components: {product},
		data() {
			return {
                update_tips: '',
				product: {},
                is_processing: 0,
                is_downloading: 0,
                is_updating: 0,
                is_downloaded: 0,
                updateForm: new Form({
                    build: '',
                    version: ''
                })
			}
		},
		mounted(){
			if(!helper.hasRole('admin')) {
				this.$router.push('/');
			}

            toastr.success(i18n.general.wait_while_loading);
			axios.get('/api/update')
				.then(response => response.data)
				.then(response => {
                    this.update_tips = response.update_tips;
					this.product = response.product;

                    if (response.is_downloaded) {
                        this.is_downloaded = 1;
                        this.updateForm.build = this.product.next_release_build;
                        this.updateForm.version = this.product.next_release_version;
                    }
				})
				.catch(error => {
					helper.showDataErrorMsg(error);
				})
		},
		methods: {
            confirmUpdate(){
                return dialog => this.update();
            },
            confirmDownload(action){
                return dialog => this.download(action);
            },
			download(action){
                this.is_processing = 1;
                this.is_downloading = 1;
                axios.post('/api/download')
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.is_downloading = 0;
                        this.is_downloaded = 1;
                        this.updateForm.build = response.release.build;
                        this.updateForm.version = response.release.version;

                        if(action)
                            this.update();
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                        this.is_processing = 0;
                        this.is_downloading = 0;
                    })
			},
            update(){
                this.is_updating = 1;
                this.updateForm.post('/api/update')
                    .then(response => {
                        toastr.success(response.message);
                        location.reload();
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                        this.is_processing = 0;
                        this.is_updating = 0;
                    })
            },
            getFileSize(size){
                return helper.bytesToSize(size);
            }
		},
        filters: {
          moment(date) {
            return helper.formatDate(date);
          }
        },
        computed: {
            checkSupportValidity(){
                if (moment().format('YYYY-MM-DD') <= this.product.date_of_support_expiry)
                    return true;
                else
                    return false;
            }
        }
	}
</script>
